import Image from 'next/image';
import logo from '@/assets/svg/home/image 310.svg';
import { PiMapPinArea } from 'react-icons/pi';
import Link from 'next/link';
import { formatName } from '@/constant/scripts';

const CentersCard = ({
    className,
    data,
}: {
    className?: string;
    data: {
        id: number;
        name: string;
        pic: string;
        role: string;
        city: {
            name: string;
            slug: string;
        };
    };
}) => {
    return (
        <Link
            target="_blank"
            href={
                ['lab', 'ImagingCenter'].includes(data.role)
                    ? `/${data.role}/${data.id}/${formatName(data.name)}`
                    : `/center/${data.role}/${
                          data?.city ? data.city.slug : 'city'
                      }/${data.id}`
            }
            className={`${className} p-4 bg-white rounded-2xl block`}
        >
            <div className="relative pb-12">
                <Image
                    unoptimized
                    className="w-full h-[130px] sm:!h-[170px] rounded-2xl"
                    alt={`تصویر ${data.name} `}
                    src={
                        data.pic
                            ? process.env.NEXT_PUBLIC_STATIC_URL + data.pic
                            : ''
                    }
                    width={1000}
                    height={1000}
                />
                <div className="rounded-full absolute bottom-[14px] left-1/2 -translate-x-1/2 bg-lavender p-2">
                    <Image
                        className="sm:!size-12 size-9"
                        alt="لوگو"
                        src={logo}
                        width={1000}
                        height={1000}
                    />
                </div>
            </div>
            <p className="font-bold text-md w-full text-center">{data.name}</p>
            <div className="gap-1.5 flex items-center">
                <PiMapPinArea className="text-xl xs:!block hidden text-[#222222A3] min-w-[25px] smp:!min-w-[32px]" />
                <p className="!text-[16px] text-[#222222A3] pt-2">
                    {data.city?.name ? data.city.name : ''}
                </p>
            </div>
        </Link>
    );
};

export default CentersCard;
